import { Controller } from "@hotwired/stimulus"
import { eventListeners } from "@popperjs/core";

// Connects to data-controller="select-colour"
export default class extends Controller {
  connect() {
    let select  = this.element.querySelector('select');
    select.addEventListener('change', () => {
      select.classList.remove('placeholder');
    })
  }
}
